var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v("This test link is "),_c('b',[_vm._v("invalid")]),_vm._v(" or has "),_c('b',[_vm._v("expired")]),_vm._v(".")]),_c('p',[_vm._v("Please contact your test administrator.")])])
}]

export { render, staticRenderFns }